module.exports = __webpack_public_path__ + "img/Raw_material_1200x800.6a5c6b56.png";